module.exports = __webpack_public_path__ + "r-v3/img/ml_13_00.6e3f6ee2.jpg";